import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../../html/checkbox'
import { Element } from '../../../../html/element'
import { SelectCustom } from '../../../../selectCustom'
import { SCROLL_COMPONENT_IDS } from '../../../constant'
import {
  changeListSelectedListBusinessAge,
  selectDataBusinessAge,
  selectListSelectedBusinessAge,
} from '../../../store/sliceBusinessAge'
import classes from '../index.module.scss'
import { LayoutContent } from '../layoutContent'

export const YearsOfOperation = () => {
  const dispatch = useDispatch()

  const dataBusinessSize = useSelector(selectDataBusinessAge)
  const listSelected = useSelector(selectListSelectedBusinessAge)

  //Actions
  const handleChoose = (value) => {
    dispatch(changeListSelectedListBusinessAge(value))
  }

  return (
    <div className={classes.businessAge}>
      <div className={classes.select}>
        <SelectCustom
          renderActiveItem={() => (
            <Translate value="library.filterSetting.YEAR_ACTIVE_HOLDER" />
          )}
          data={[{}]}
          style={{ minHeight: 28 }}
          scrollId={SCROLL_COMPONENT_IDS}
        >
          {() => (
            <Element
              style={{
                padding: 12,
                width: 220,
                backgroundColor: '#FFFFFF',
              }}
            >
              {dataBusinessSize?.map((item) => (
                <DropdownItem
                  key={item?.value}
                  item={item}
                  listSelected={listSelected}
                  handleChoose={handleChoose}
                />
              ))}
            </Element>
          )}
        </SelectCustom>
      </div>
      {!!listSelected?.length && (
        <Element
          elementName="p"
          style={{
            fontStyle: 'italic',
            padding: '4px 0',
          }}
        >
          <Translate
            value={`library.main.${
              !listSelected?.length || listSelected?.length < 2
                ? 'ITEM_SINGLE_SELECT'
                : 'ITEM_SELECT'
            }`}
            count={listSelected?.length}
          />
        </Element>
      )}

      <LayoutContent data={listSelected} onClickDelete={handleChoose} />
    </div>
  )
}

export const DropdownItem = ({ item, handleChoose, listSelected }) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#F3F3F3')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onClick={(e) => {
        handleChoose(item)
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor }}
      className="cursorPointer"
    >
      <Element
        style={{
          borderBottom: '1px solid #D5D5D5',
        }}
      >
        <Checkbox
          title={item.label}
          checked={listSelected.map((item) => item.value).includes(item.value)}
          onChange={() => {
            handleChoose(item)
          }}
          isCheckOnClickText
          styleIcon={{ fontSize: 15, paddingRight: 8 }}
          style={{ padding: '6px 0' }}
        />
      </Element>
    </Element>
  )
}
